module.exports = __webpack_public_path__ + "8d7f4495aed163ffbb1014723ba5bf97.pdf";